<!-- 取消变更订单弹框 -->
<template>
    <el-dialog @close="close" :close-on-click-modal="false" :close-on-press-escape="false" center append-to-body
        :visible.sync="dialogVisible" width="80%">
        <div class="title">订单确认后变更</div>
        <main id="main">
            <div class="mainTitle"><i class="el-icon-info icon1"></i> 变更说明</div>
            <!-- <div class="textPrompt">
                <p class="textPromptP1">您的订单已确认。若您需要 <span>减少</span> 产品的数量或日期，可能会产生取消费用。</p>
                <p class="textPromptP2">该订单的取消政策为： <span>法国巴黎4星酒店 免费取消</span> </p>
            </div> -->
            <div class="table">
                <div class="tableLeft" v-if="tableData.length > 0">
                    {{ resourceType.find(n => n.code == tableData[0].orderChildren.state).name1 }}
                </div>
                <el-table v-loading="loading" :header-cell-style="{ background: '#FBEFE8', color: '#000' }"
                    :data="tableData" style="width: 100%">
                    <el-table-column prop="useDate" align="center" label="使用日期" width="150">
                    </el-table-column>
                    <el-table-column prop="productStockName" align="center" label="产品名称" width="160">
                        <template slot-scope="scope">
                            {{ scope.row.orderChildren.resourceName ? scope.row.orderChildren.resourceName :
                                scope.row.orderChildren.resourceNameEn }} ({{ scope.row.productStockName }})
                        </template>
                    </el-table-column>
                    <el-table-column prop="productDesc" align="center" label="产品说明">
                    </el-table-column>
                    <el-table-column prop="productNumber" align="center" label="己确认数量">
                    </el-table-column>
                    <el-table-column width="120" prop="address" class-name="column" align="center" label="需要减少">
                        <template slot-scope="scope">
                            <el-input-number size="small" @change="deleteNumClick(scope.row)"
                                v-model="scope.row.dwindleNumbersconst" :min="scope.row.dwindleNumbersconst > 0 ? 1 : 0"
                                :max="scope.row.productNumber"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" prop="address" class-name="column" align="center" label="需要增加">
                        <template slot-scope="scope">
                            <div v-for="(item, index) in scope.row.productList" :key="index">
                                <el-input-number v-if="item.id" size="small" v-model="item.number" :min="0"
                                    :max="scope.row.productNumber"></el-input-number>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" align="center" label="操作">
                        <template slot-scope="scope">
                            <div style="display: flex;align-items: center;justify-content: center;">
                                <span style="color: #BF6642;margin-right: 0.05rem;">其它产品</span> <i
                                    @click="addRoom(scope.row)" style="color: #BF6642;font-size: 0.2rem;cursor: pointer;"
                                    class="el-icon-circle-plus-outline"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="150" prop="address" align="center" label="选择产品">
                        <template slot-scope="scope">
                            <div class="lineBox" v-for="(item, index) in scope.row.productList" :key="index">
                                <div class="lineData" v-if="!item.id">
                                    <budgetProductFuzzySearch :isFilter="true" :filterName="scope.row.productStockName"
                                        v-if="orderTypeList.includes(scope.row.orderChildren.orderType)"
                                        :state="scope.row.orderChildren.state" keys="productNameCn" :data="item">
                                    </budgetProductFuzzySearch>
                                    <basicProductFuzzySearch v-else :isFilter="true"
                                        :filterName="scope.row.productStockName" :rid="scope.row.orderChildren.resourceId"
                                        :state="scope.row.orderChildren.state" keys="productNameCn" :data="item">
                                    </basicProductFuzzySearch>
                                    <i v-if="scope.row.productList.length > 1"
                                        @click="deleteRoom(scope.row.productList, index)"
                                        style="font-size: 0.3rem;margin-left: 0.05rem;cursor: pointer;"
                                        class="el-icon-circle-close"></i>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" prop="address" align="center" class-name="column" label="需要增加">
                        <template slot-scope="scope">
                            <div class="lineBox" v-for="(item, index) in scope.row.productList" :key="index">
                                <el-input-number v-if="!item.id" size="small" v-model="item.number" :min="0"
                                    :max="scope.row.productNumber"></el-input-number>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="describe">
                <p class="describeP1">其他增加的需求：</p>
                <el-input style="width: 9rem;" v-model="remark" placeholder="请输入内容"></el-input>
            </div>
            <el-divider></el-divider>
            <el-card class="box-card">
                <div class="box">
                    <div class="box-card-left">
                        <p class="box-card-left-p1">基于您上述的调整，根据取消政策， <span>减少的项目</span>费用变化明细如下：</p>
                        <div class="box-card-left-bottom" v-if="JSON.stringify(reducedRenderingData) !== '{}'">
                            <!-- <div class="box-card-left-bottom-left">
                                2022-12-09
                            </div> -->
                                <div class="box-card-left-bottom-right">
                                    <el-card class="box-card"
                                        v-for="(item, index) in reducedRenderingData"
                                        :key="index">
                                        <p style="width: 1.3rem;">{{ item.useDate }}</p>
                                        <p>己付 ¥{{ item.amountPaid }}</p>
                                        <p>取消费用 ¥{{ item.cancelFees }}</p>
                                        <p style="width: 1.3rem;">可退 ¥{{ item.refundableAmount }}</p>
                                        <div class="box-card-right">
                                            <p v-html="item.cancellationPolicyDescription"></p>
                                            <el-link type="danger">取消费用不合理? 点击此处与商家沟通</el-link>
                                        </div>
                                    </el-card>
                                    <div class="box-card-left-bottom-right-bottm">
                                        <p style="width: 1.3rem;"></p>
                                        <p class="box-card-left-bottom-right-bottm-p1">预计十个工作日内退款</p>
                                        <p class="box-card-left-bottom-right-bottm-p2">可退款金额(共)： <span>¥{{
                                                totalRefundableAmount() }}</span></p>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card">
                <div class="box">
                    <div class="box-card-left">
                        <p class="box-card-left-p1">基于您上述的调整，您需要<span>增加的项目</span>为： </p>
                        <div v-for="(item, index) in mergeOrder" :key="index">
                            <div class="box-card-left-bottom">
                                <div class="box-card-left-bottom-left">
                                    {{ item.useDate }}
                                </div>
                                <div class="box-card-left-bottom-right" v-for="(item1, index1) in item.arr" :key="index1">
                                    <div class="box-card-left-bottom-right-top">
                                        <div style="display:flex;align-items: center;">
                                            <span style="margin-right: 0.1rem;">{{ item1.nameCn }}</span>
                                            <div style="margin-right: 0.1rem;a" v-for="(item2, index2) in item1.productArr"
                                                :key="index2">
                                                <span style="color: #BF6642;">{{ item2.productNameCn }} </span>{{
                                                    item2.number }}{{ item2.useTime }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-card>
        </main>
        <span slot="footer" class="dialog-footer">
            <el-button @click="send" style="color: #BF6642;" size="small">确认井发送需求</el-button>
        </span>
    </el-dialog>
</template>
<script>
import OrderApi from '../../../../../components/Api/order'
import Api from '../../../../../components/Api'
import basicProductFuzzySearch from './basicProductFuzzySearch.vue'
import budgetProductFuzzySearch from './budgetProductFuzzySearch.vue'
import { resourceType, getGroup } from '@/assets/utils/unit'
export default {
    components: {
        budgetProductFuzzySearch,
        basicProductFuzzySearch
    },
    props: {
        childrenIds: {
            type: Array,
            default: () => []
        },
        allDatas: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            remark: '',//其他增加的需求
            resourceType,
            reducedRenderingData: [],//减少的渲染数据
            partialCancellationOfData: [],//部分取消的数据
            orderTypeList: [1, 5],
            loading: true,
            input1: null,
            dialogVisible: false,
            tableData: []
        }
    },
    computed: {
        totalRefundableAmount() {
            return function () {
                return this.reducedRenderingData.length === 0 ? 0 : this.reducedRenderingData.map(x => x.refundableAmount)
                    .reduce((m,n) => m + n)
            }
        },
        addProductList() {
            let arr = []
            this.tableData.forEach(item => {
                item.productList.forEach(item1 => {
                    arr.push(item1)
                })
            })
            return arr
        },
        mergeOrder() {
            let arr = []
            this.tableData.forEach(item => {
                item.productList.forEach(item1 => {
                    arr.push(item1)
                })
            })
            let arr1 = arr.filter(item => item.number && item.productNameCn)
            let result = this.mergeOrderData(arr1)
            return result
        }
    },
    watch: {},
    methods: {
        close() {
           // this.reducedRenderingData = {}
            this.reducedRenderingData = []
        },
        initClick() {
            this.dialogVisible = true
            this.modifyOrderList()
        },
        //减少的数量
        deleteNumClick(val) {
            let obj = {
                "cancelNumber": val.dwindleNumbersconst,
                "orderChildrenId": val.orderChildrenId,
                "stockId": val.stockId,
                "useDate": val.useDate,
                "childrenDetailId": val.id,
            }
            this.loading = true
            new OrderApi('order').modifyOrderCancel(obj).then(res => {
                if (res.status == 200) {
                    // this.reducedRenderingData = res.data
                    // console.log("res.data",res.data)
                    for (let i = 0; i < res.data.modifyOrderCancelDetailResultList.length; i++) {
                        let v = res.data.modifyOrderCancelDetailResultList[i]
                        let findIndex = this.reducedRenderingData.findIndex(x => x.stockId === v.stockId && x.useDate === v.useDate)
                        if (findIndex === -1) {
                            this.reducedRenderingData.push(v)
                        } else {
                            this.reducedRenderingData[findIndex] = v
                        }
                    }
                    let index = this.partialCancellationOfData.findIndex(n => n.childrenDetailId === obj.childrenDetailId)
                    if (index === -1) {
                        this.partialCancellationOfData.push(obj)
                    } else {
                        let find = this.partialCancellationOfData[index]
                        find.cancelNumber = val.dwindleNumbersconst
                    }
                    this.loading = false
                } else {
                    this.$message.error({ message: res.statusText })
                    val.dwindleNumbersconst = val.dwindleNumbersconst - 1
                }
            }).catch((error) => {
                console.log("catch",error)
                this.loading = false
                val.dwindleNumbersconst = val.dwindleNumbersconst - 1
                this.$message({
                    type: 'error',
                    message: '减少失败!'
                });
            })
        },
        mergeData(dataList) {
            const mergedList = [];
            const mergedMap = new Map();
            dataList.forEach(item => {
                const key = `${item.nameCn}-${item.useDate}`;
                if (!mergedMap.has(key)) {
                    mergedMap.set(key, { ...item });
                    mergedList.push(mergedMap.get(key));
                } else {
                    mergedMap.get(key).number += item.number;
                }
            });
            return mergedList;
        },
        //付款后的订单部分取消
        partialCancellationOfOrder() {
            if (this.partialCancellationOfData.length > 0) {
                new OrderApi('order').orderPartHasBeenPaidAndCancelled(this.partialCancellationOfData).then(res => {
                    if (res.status == 200) {
                        this.dialogVisible = false
                        this.$message({
                            type: 'success',
                            message: '发送成功!'
                        });
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.statusText
                        });
                    }
                })
            }
        },
        //确认并发送
        send() {
            let arr = this.addProductList.filter(item => item.number && item.productNameCn)
            console.log(arr,this.partialCancellationOfData,'asdsadasdsad');
            this.$confirm('确认发送此需求吗, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (arr.length > 0) {
                    let obj = {
                        "orderChildrenId": this.allDatas.orderChildrenId,
                        "orderInquiryDetailRequestList": arr,
                        "orderMainId": this.allDatas.orderMainId,
                        "remark": this.remark,
                        "orderType": arr[0].orderType,
                        "state": arr[0].state
                    }
                    new Api('inquiry').orderInquiryAdd(obj).then(res => {
                        if (res.status == 200) {
                            if (this.partialCancellationOfData.length > 0) {
                                this.partialCancellationOfOrder()
                            } else {
                                this.dialogVisible = false
                                this.$message({
                                    type: 'success',
                                    message: '发送成功!'
                                });
                            }
                        } else {
                            this.$message({
                                type: 'warning',
                                message: res.statusText
                            });
                        }
                    })
                } else if (this.partialCancellationOfData.length > 0) {
                    this.partialCancellationOfOrder()
                } else {
                    this.$message({
                        type: 'warning',
                        message: '没有新增数据'
                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '发送失败!'
                });
            });
        },
        //需要变更的订单列表
        modifyOrderList() {
            let obj = {
                "page": 1,
                "q": {
                    childrenIds: this.childrenIds,
                },
                "size": 100
            }
            new OrderApi('order').modifyOrderDetail(obj).then(res => {
                if (res.status == 200) {
                    this.tableData = res.data.records
                    this.tableData.forEach(item => {
                        this.$set(item, 'productList', [])
                        this.$set(item, 'dwindleNumbersconst', 0) //减少的数量
                        let obj = {
                            id: item.id,//id
                            currency: item.currency,
                            state: item.orderChildren.state,
                            orderType: item.orderChildren.orderType,
                            number: 0,//需要增加到数量
                            productNameCn: item.productStockName,
                            useDate: item.useDate,
                            useTime: item.useTime,
                            cityName: item.orderChildren.linkName,
                            nameCn: item.orderChildren.resourceName,
                            rid: item.orderChildren.resourceId,
                        }
                        item.productList.push(obj)
                    })
                    this.loading = false
                } else {
                    this.$message.error({ message: res.statusText })
                }
            })
        },
        //添加其它房型
        addRoom(data) {
            let obj = {
                id: '',//id
                currency: data.currency,
                state: data.orderChildren.state,
                orderType: data.orderChildren.orderType,
                number: 0,//需要增加到数量
                productNameCn: '',
                useDate: data.useDate,
                useTime: data.useTime,
                cityName: data.orderChildren.linkName,
                nameCn: data.orderChildren.resourceName,
                rid: data.orderChildren.resourceId,
            }
            data.productList.push(obj)
            this.$message.success({ message: '新增成功!' })
        },
        //删除房型
        deleteRoom(data, index) {
            this.$delete(data, index)
            this.$message.success({ message: '删除成功!' })
        },
        mergeOrderData(data) {
            let result = Object.values(data.reduce((acc, curr) => {
                const key = `${curr.useDate}-${curr.nameCn}`;
                if (!acc[key]) {
                    acc[key] = { ...curr, arr: [{ nameCn: curr.nameCn, productArr: [{ productNameCn: curr.productNameCn, useTime: curr.useTime, number: curr.number }] }] };
                } else {
                    const productArr = acc[key].arr.find(item => item.nameCn === curr.nameCn).productArr;
                    const productIndex = productArr.findIndex(item => item.productNameCn === curr.productNameCn);
                    if (productIndex === -1) {
                        productArr.push({ productNameCn: curr.productNameCn, useTime: curr.useTime, number: curr.number });
                    } else {
                        productArr[productIndex].number += curr.number;
                    }
                }
                return acc;
            }, {}));
            let finalResult = [];
            result.forEach(item => {
                const index = finalResult.findIndex(entry => entry.useDate === item.useDate);
                if (index === -1) {
                    finalResult.push({ useDate: item.useDate, arr: item.arr });
                } else {
                    finalResult[index].arr.push(...item.arr);
                }
            });

            return finalResult
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-dialog__header {
    padding: 0 !important;
}

/deep/ .el-dialog__body {
    padding: 0 !important;
}

/deep/ .el-dialog__close {
    color: #fff !important;
}

/deep/ .el-dialog__headerbtn {
    top: 0.1rem !important;

}

/deep/ .column {
    color: #BF6642 !important;
}

.el-dialogOrderChangePopup {
    height: 85vh;
    overflow-y: scroll;
}

.title {
    height: 0.5rem;
    background-color: #BF6642;
    color: #fff;
    font-size: 0.2rem;
    line-height: 0.5rem;
    padding-left: 0.5rem;
    margin-bottom: 0.1rem;
}

#main {
    padding: 0 0.5rem;

    .mainTitle {
        font-weight: bold;
        margin-bottom: 0.1rem;

        .icon1 {
            color: #BF6642;
            margin-right: 0.1rem;
        }
    }

    .textPrompt {
        margin-bottom: 0.1rem;

        .textPromptP1 {
            color: #BF6642;
            font-weight: bold;
            margin-bottom: 0.05rem;
        }

        .textPromptP2 {
            span {
                font-weight: bold;
            }
        }
    }

    .table {
        margin-bottom: 0.2rem;
        display: flex;

        .tableLeft {
            width: 0.5rem;
            background-color: #F9EFE9;
            font-weight: bold;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .lineBox {
        .lineData {
            margin-bottom: 0.05rem;
            display: flex;
            align-items: center;
        }
    }

    .describe {
        display: flex;
        align-items: center;
        margin-bottom: 0.2rem;

        .describeP1 {
            font-weight: bold;
        }
    }

    .box-card {
        margin-bottom: 0.3rem;

        .box {
            display: flex;
            justify-content: space-between;
        }

        .box-card-left {
            .box-card-left-p1 {
                margin-bottom: 0.15rem;

                span {
                    color: #BF6642;
                }
            }

            .box-card-left-bottom {
                display: flex;

                .box-card-left-bottom-left {
                    width: 1rem;
                }

                .box-card-left-bottom-right {
                    .box-card-left-bottom-right-top {
                        display: flex;

                        p {
                            width: 1.8rem;
                            margin-bottom: 0.1rem;
                        }
                    }

                    .box-card-left-bottom-right-bottm {
                        display: flex;

                        p {
                            width: 1.8rem;
                        }

                        .box-card-left-bottom-right-bottm-p1 {
                            color: #C2C2C2;
                        }

                        .box-card-left-bottom-right-bottm-p2 {
                            font-weight: bold;

                            span {
                                color: red;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
